import { persistor, store } from './redux-store/root-store';
export const RootStore = {
  store,
  persistor,
};
